import React from 'react';
import { Link, useNavigate, useParams } from "react-router-dom"
import { BaseUrl } from '../../helper/BaseUrl';
import { DateConvert } from '../../helper/DateConvert';
import { useModal } from '../../contexts/ModalContext';
import ContactForm from '../contactUs/ContactForm';
import { fetchJson } from '../../helper/fetchJson';
import GlobalFaq from '../../components/GlobalFaq';
export default function AiDetailContent({ initialData }) {
  
  const { slug } = useParams();
  const [aiData, setAiData] = React.useState(initialData || {});
  const [pageUrl, setPageUrl] = React.useState("");
  const [copied, setCopied] = React.useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      setPageUrl(window.location.href);
    }
  }, [slug]);

  const handleCopy = async () => {
    if (typeof window !== "undefined" && pageUrl) {
      try {
        await navigator.clipboard.writeText(pageUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 10000); // reset after 10s
      } catch (err) {
        console.error("Copy failed:", err);
      }
    }
  };

  React.useEffect(() => {
    let active = true;

    if (initialData?.slug === slug) {
      setAiData(initialData);
    } else {
      fetchJson(`${BaseUrl}/api/aiblog/view/${slug}`)
        .then((result) => {
          if (!active) return;
          if (!result?.blog) {
            navigate("/404");
            return;
          }
          setAiData(result.blog);
        })
        .catch((error) => console.error('Fetch error:', error.message));
    }

    return () => {
      active = false;
    };
  }, [slug, initialData, navigate])

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -90; // 👈 offset from top (90px)
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }
  };

  const { openQueryModal } = useModal();

  return (
    <>
      <section className="blog-deatail-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="press-detail-left">
                <ul className="supply-breadcrumb">
                  <li> <Link to="/">Home</Link>  </li>
                  {/* <li className="space-line"> <i className="fa-solid fa-chevron-right"></i>   </li> */}
                  <li className="space-line"> | </li>
                  <li>   <Link className="breadcumb-details" to={"/blogs"}>   Blog  </Link>  </li>
                  {/* <li className="space-line">  <i className="fa-solid fa-chevron-right"></i>  </li> */}
                  <li className="space-line"> | </li>
                  <li>{aiData?.name?.slice(0, 12) + "..."}</li>
                </ul>
                <div className="press-heading"> <h1 className="heading">{aiData?.name}</h1>  </div>
                <div className="press-social">
                  <div className="left-sec">
                    <div className="author-img">
                      <img src={BaseUrl + aiData?.author_image} className="img-responsive" alt={aiData?.author_name} />
                    </div>
                    <div className="author-name">
                      <div className="author"><span> Written by {aiData?.author_name}  </span></div>
                      <div className="date"><span>{DateConvert(aiData?.date)}</span></div>
                    </div>
                  </div>
                  <div className="right-sec">
                    <div className="press-social-inner">
                      <div className="footer-social">
                        <ul className="social-items">
                          <li title={copied ? "Copied!" : "Copy link"}>
                            <Link to="#" onClick={handleCopy} rel="noopener noreferrer">  <i className="fa-solid fa-link"></i>  </Link>
                          </li>
                          <li>
                            <a target='_blank' rel="noopener noreferrer" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`}>
                              <i className="fab fa-facebook-f"></i>
                            </a>
                          </li>
                          <li>
                            <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                              <i className="fa-brands fa-instagram"></i>
                            </a>
                          </li>
                          <li>
                            <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(pageUrl)}`} target="_blank" rel="noopener noreferrer">
                              <i className="fa-brands fa-x-twitter"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="press-image-section">
                  <img src={BaseUrl + aiData?.section_image} className="img-responsive" alt="Blog" />
                </div>
                <div className="press-content-sec">
                  <div className="press-content-sec-inner">
                    <div className="row intro-row">
                      <div className="col-lg-9">
                        <div className="case-text-details">
                          {aiData?.heading1 && <h2 className="heading" id="one">{aiData?.heading1}</h2>}
                          {aiData?.description1 && <div dangerouslySetInnerHTML={{ __html: aiData?.description1 }} />}
                          {aiData?.heading2 && <h3 className="heading" id="two">{aiData?.heading2}</h3>}
                          {aiData?.description2 && <div dangerouslySetInnerHTML={{ __html: aiData?.description2 }} />}
                          {aiData?.section_image2 &&
                            <div className="ai-blog-wrap">
                              <img src={BaseUrl + aiData?.section_image2} alt="Accessibility" className="img-responsive" loading="lazy" />
                            </div>   }
                          {aiData?.heading3 && <h3 className="heading" id="three">{aiData?.heading3}</h3>}
                          {aiData?.description3 && <div dangerouslySetInnerHTML={{ __html: aiData?.description3 }} />}
                          {aiData?.heading4 && <h3 className="heading" id="four">{aiData?.heading4}</h3>}
                          {aiData?.description4 && <div dangerouslySetInnerHTML={{ __html: aiData?.description4 }} />}

                          {aiData?.section_image3 &&
                            <div className="ai-blog-wrap">
                              <img src={BaseUrl + aiData?.section_image3} alt="Accessibility" className="img-responsive" loading="lazy" />
                            </div>   }
                          {aiData?.heading5 && <h3 className="heading" id="five">{aiData?.heading5}</h3>}
                          {aiData?.description5 && <div dangerouslySetInnerHTML={{ __html: aiData?.description5 }} />}
                          {aiData?.heading6 && <h3 className="heading" id="six">{aiData?.heading6}</h3>}
                          {aiData?.description6 && <div dangerouslySetInnerHTML={{ __html: aiData?.description6 }} />}
                          {aiData?.heading7 && <h3 className="heading" id="seven">{aiData?.heading7}</h3>}
                          {aiData?.description7 && <div dangerouslySetInnerHTML={{ __html: aiData?.description7 }} />}
                          {aiData?.heading8 && <h3 className="heading" id="eight">{aiData?.heading8}</h3>}
                          {aiData?.description8 && <div dangerouslySetInnerHTML={{ __html: aiData?.description8 }} />}
                          {aiData?.heading9 && <h3 className="heading" id="nine">{aiData?.heading9}</h3>}
                          {aiData?.description9 && <div dangerouslySetInnerHTML={{ __html: aiData?.description9 }} />}
                          {aiData?.heading10 && <h3 className="heading" id="ten">{aiData?.heading10}</h3>}
                          {aiData?.description10 && <div dangerouslySetInnerHTML={{ __html: aiData?.description10 }} />}
                        </div>
                        <div className="blog-faq">
                        <GlobalFaq/>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="case-index-link">
                          <ul className="dots-style">
                            <span className="subtitle">content</span>
                            {aiData?.heading1 && <li><a href="#one" onClick={(event) => { event.preventDefault(); handleScroll("one"); }}>{aiData?.heading1?.length > 40 ? aiData?.heading1?.slice(0, 40) + "..." : aiData?.heading1}</a></li>}

                            {aiData?.heading2 && <li><a href="#two" onClick={(event) => { event.preventDefault(); handleScroll("two"); }}>{aiData?.heading2?.length > 40 ? aiData?.heading2?.slice(0, 40) + "..." : aiData?.heading2}</a></li>}
                            {aiData?.heading3 && <li><a href="#three" onClick={(event) => { event.preventDefault(); handleScroll("three"); }}>{aiData?.heading3?.length > 40 ? aiData?.heading3?.slice(0, 40) + "..." : aiData?.heading3}</a></li>}
                            {aiData?.heading4 && <li><a href="#four" onClick={(event) => { event.preventDefault(); handleScroll("four"); }}>{aiData?.heading4?.length > 40 ? aiData?.heading4?.slice(0, 40) + "..." : aiData?.heading4}</a></li>}
                            {aiData?.heading5 && <li><a href="#five" onClick={(event) => { event.preventDefault(); handleScroll("five"); }}>{aiData?.heading5?.length > 40 ? aiData?.heading5?.slice(0, 40) + "..." : aiData?.heading5}</a></li>}
                            {aiData?.heading6 && <li><a href="#six" onClick={(event) => { event.preventDefault(); handleScroll("six"); }}>{aiData?.heading6?.length > 40 ? aiData?.heading6?.slice(0, 40) + "..." : aiData?.heading6}</a></li>}
                            {aiData?.heading7 && <li><a href="#seven" onClick={(event) => { event.preventDefault(); handleScroll("seven"); }}>{aiData?.heading7?.length > 40 ? aiData?.heading7?.slice(0, 40) + "..." : aiData?.heading7}</a></li>}
                            {aiData?.heading8 && <li><a href="#eight" onClick={(event) => { event.preventDefault(); handleScroll("eight"); }}>{aiData?.heading8?.length > 40 ? aiData?.heading8?.slice(0, 40) + "..." : aiData?.heading8}</a></li>}
                            {aiData?.heading9 && <li><a href="#nine" onClick={(event) => { event.preventDefault(); handleScroll("nine"); }}>{aiData?.heading9?.length > 40 ? aiData?.heading9?.slice(0, 40) + "..." : aiData?.heading9}</a></li>}
                            {aiData?.heading10 && <li><a href="#ten" onClick={(event) => { event.preventDefault(); handleScroll("ten"); }}>{aiData?.heading10?.length > 40 ? aiData?.heading10?.slice(0, 40) + "..." : aiData?.heading10}</a></li>}
                          </ul>


                          <div className="blog-detail-form">
                            <div className="detail-form-inner">
                              <div className="heading">Get Your Personalized Expert Guidance</div>
                              <div className="btn-wrapper">
                                <Link className="theme-btn" onClick={openQueryModal}>  <span> Book A Demo Now </span>   </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="blog-bottom-form">
                      <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-11">
                          <div className="form-text">
                            <span className="heading ">Speak to an Expert Today!</span>
                            <p> Get in touch with our battle-tested sustainability, technology, and TMS specialists to explore tailored green logistics solutions.</p>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="blog-form-content">
                            <div className="row align-items-center">
                              <div className="col-md-6">
                                <div className="image-wrapper">
                                  <img src="/assets/images/form-bottom-img.webp" alt="form" className="img-responsive" />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="enquery-popup-form">
                                  <ContactForm />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
